import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { EffectsModule } from "@ngrx/effects";
import { TelemetryEffects } from "./+state/effects";
import {
  RtpCapabilityService,
  TelemetryDataService,
  TelemetryService
} from "./+state/service";

@NgModule({
  imports: [
    CommonModule,
    MatSnackBarModule,
    EffectsModule.forFeature([TelemetryEffects])
  ],
  providers: [TelemetryService, TelemetryDataService, RtpCapabilityService]
})
export class TelemetryDataAccessModule {}
